import { render, staticRenderFns } from "./lcslHistory.vue?vue&type=template&id=edbb3e1c&scoped=true&"
import script from "./lcslHistory.vue?vue&type=script&lang=js&"
export * from "./lcslHistory.vue?vue&type=script&lang=js&"
import style0 from "./lcslHistory.vue?vue&type=style&index=0&id=edbb3e1c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbb3e1c",
  null
  
)

export default component.exports